import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

const axios = require('axios');
const url = process.env.REACT_APP_URI
const companyId = process.env.REACT_APP_COMPANY_ID
const user = localStorage.getItem("userAccess");
const header = `Bearer ${user}`;

export const getAddons = createAsyncThunk(
    'addons/getAddons',
    async (args, thunkAPI) => {
        const { pageSize, pageNumber, searchQuery, eventId } = args;

        const response = await axiosInstance.request({
            url: `/events/${eventId}/AddOns`,
            method: 'get',
            params: { pageSize, pageNumber, searchQuery }
        });
        return { data: response };
    }
);

export const getAddonsToExport = createAsyncThunk(
    'addons/getAddonsToExport',
    async ({ addonId, eventId }, thunkAPI) => {
        const response = await axiosInstance.request({
            url: `/events/${eventId}/AddOns/${addonId}/tickets/export`,
            method: 'get',
        });
        return { data: response.data };
    }
);

export const getAddonsById = createAsyncThunk(
    'addons/getAddonsById',
    async (args, thunkAPI) => {
        const response = await axiosInstance.request({
            url: `/events/${args.eventId}/AddOns/${args.intId}`,
            method: 'get'
        });
        return { data: response.data };
    }
);

export const getTicketsById = createAsyncThunk(
    'addons/getTicketsById',
    async (args, thunkAPI) => {
        const { pageSize, pageNumber, searchQuery, eventId, addonId } = args;

        const response = await axiosInstance.request({
            url: `/events/${eventId}/AddOns/${addonId}/tickets`,
            method: 'get',
            params: { pageSize, pageNumber, searchQuery }
        });
        return { data: response };
    }
);

export const addonsSlice = createSlice({
    name: 'addons',
    initialState: {
        addons: [],
        totalRows: 0,
        addonsById: [],
        inputSearch: "",
        addonsToExport: [],
        addonsToSelect: [],
        ticketsByAddons: [],
        pendingAddons: false,
        totalRowsOfTickets: 0,
        pendingTickets: false,
        pendingAddonsById: false,
        pendingAddonsToExport: false,
    },
    reducers: {
        clearAddons: (state) => {
            state.addonsById = [];
        },
        setInputSearch: (state, action) => {
            state.inputSearch = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAddons.fulfilled, (state, action) => {
                const { data } = action.payload.data;
                const auxAddons = [];
                state.addons = data;
                state.totalRows = JSON.parse(action?.payload.data?.headers["x-pagination"])?.totalCount;
                state.pendingAddons = false;
                data.forEach(element => {
                    auxAddons.push({ value: element.id, label: element.name });
                });
                state.addonsToSelect = auxAddons;
            })
            .addCase(getAddons.pending, (state) => {
                state.pendingAddons = true;
            })
            .addCase(getAddons.rejected, (state) => {
                state.pendingAddons = false;
            })
            .addCase(getAddonsById.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.addonsById = data;
                state.pendingAddonsById = false;
            })
            .addCase(getAddonsById.pending, (state) => {
                state.pendingAddonsById = true;
            })
            .addCase(getAddonsById.rejected, (state) => {
                state.pendingAddonsById = false;
            })
            .addCase(getTicketsById.fulfilled, (state, action) => {
                const { data } = action.payload.data;
                state.totalRowsOfTickets = JSON.parse(action?.payload.data?.headers["x-pagination"])?.totalCount;
                state.ticketsByAddons = data;
                state.pendingTickets = false;
            })
            .addCase(getTicketsById.pending, (state) => {
                state.pendingTickets = true;
            })
            .addCase(getTicketsById.rejected, (state) => {
                state.pendingTickets = false;
            })
            .addCase(getAddonsToExport.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.addonsToExport = data.data;
                state.pendingAddonsToExport = false;
            })
            .addCase(getAddonsToExport.pending, (state) => {
                state.pendingAddonsToExport = true;
            })
            .addCase(getAddonsToExport.rejected, (state) => {
                state.pendingAddonsToExport = false;
            })
    }
})

export const { clearAddons, setInputSearch } = addonsSlice.actions;

export default addonsSlice.reducer